import Icon from "./Icon";
type PropsType = {
    quantity: number;
    max?: number;
    min?: number;
    disabled?: boolean;
    label?: React.ReactNode;
    alert?: React.ReactNode;
    onChange?: (amount: number) => void;
    onDecrement?: () => void;
    onIncrement?: () => void;
};

const QuantityControl = ({ min = 0, max, ...props }: PropsType) => {
    const handleIncrementClick = () => {
        handleQuantityChange?.(1);
        props.onIncrement?.();
    };

    const handleDecrementClick = () => {
        handleQuantityChange?.(-1);
        props.onDecrement?.();
    };

    const handleQuantityChange = (amount: number) => {
        props.onChange?.(props.quantity + amount);
    };

    return (
        <div
            className={`quantity-control ${
                props.disabled ? "is-disabled" : ""
            }`}
        >
            {props.label ? (
                <div className="quantity-control__label">{props.label}</div>
            ) : null}

            <div className="quantity-control__row">
                <div className="quantity-control__inner">
                    <QuantityButton
                        aria-label="Decrease quantity"
                        onClick={handleDecrementClick.bind(this)}
                        disabled={
                            min === null
                                ? props.disabled
                                : props.quantity === min || props.disabled
                        }
                    >
                        <Icon name="minus" />
                    </QuantityButton>

                    <div className="quantity-control__counter">
                        {props.quantity}
                    </div>

                    <QuantityButton
                        aria-label="Increase quantity"
                        onClick={handleIncrementClick.bind(this)}
                        disabled={
                            max === null
                                ? props.disabled
                                : max != null &&
                                  !isNaN(max) &&
                                  Number(max) === 0
                                ? true
                                : (props.quantity &&
                                      max &&
                                      props.quantity >= max) ||
                                  props.disabled
                        }
                    >
                        <Icon name="plus" />
                    </QuantityButton>
                </div>

                {props.alert ? (
                    <div className="tile__tag tile__tag--alert">
                        <span className={`tile__tag__icon`}>
                            <Icon name="exclamation" />
                        </span>
                        <div className="tile__tag__text">{props.alert}</div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

interface QuantityButtonPropsType {
    onClick: () => void;
    children: React.ReactNode;
    disabled?: boolean;
}

const QuantityButton = ({ children, ...props }: QuantityButtonPropsType) => {
    return (
        <button type="button" className="quantity-control__btn" {...props}>
            {children}
        </button>
    );
};

export default QuantityControl;
